'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var pin = require('./pin.js');

var fnv1a = require('fnv1a');

var varint = require('varint');

var dagPb = require('@ipld/dag-pb');

var utils = require('./utils.js');

var concat = require('uint8arrays/concat');

var compare = require('uint8arrays/compare');

var toString = require('uint8arrays/to-string');

var fromString = require('uint8arrays/from-string');

var sha2 = require('multiformats/hashes/sha2');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n['default'] = e;
  return Object.freeze(n);
}

var fnv1a__default = /*#__PURE__*/_interopDefaultLegacy(fnv1a);

var varint__default = /*#__PURE__*/_interopDefaultLegacy(varint);

var dagPb__namespace = /*#__PURE__*/_interopNamespace(dagPb);

var PinSet = pin.ipfs.pin.Set;

function readHeader(rootNode) {
  var rootData = rootNode.Data;

  if (!rootData) {
    throw new Error('No data present');
  }

  var hdrLength = varint__default['default'].decode(rootData);
  var vBytes = varint__default['default'].decode.bytes;

  if (vBytes <= 0) {
    throw new Error('Invalid Set header length');
  }

  if (vBytes + hdrLength > rootData.length) {
    throw new Error('Impossibly large set header length');
  }

  var hdrSlice = rootData.slice(vBytes, hdrLength + vBytes);
  var header = PinSet.toObject(PinSet.decode(hdrSlice), {
    defaults: false,
    arrays: true,
    longs: Number,
    objects: false
  });

  if (header.version !== 1) {
    throw new Error("Unsupported Set version: ".concat(header.version));
  }

  if (header.fanout > rootNode.Links.length) {
    throw new Error('Impossibly large fanout');
  }

  return {
    header: header,
    data: rootData.slice(hdrLength + vBytes)
  };
}

function hash(seed, key) {
  var buffer = new Uint8Array(4);
  var dataView = new DataView(buffer.buffer);
  dataView.setUint32(0, seed, true);
  var encodedKey = fromString.fromString(key.toString());
  var data = concat.concat([buffer, encodedKey], buffer.byteLength + encodedKey.byteLength);
  return fnv1a__default['default'](toString.toString(data));
}

function walkItems(_x, _x2) {
  return _walkItems.apply(this, arguments);
}

function _walkItems() {
  _walkItems = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blockstore, node) {
    var pbh, idx, _iterator, _step, link, linkHash, buf, _node;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pbh = readHeader(node);
            idx = 0;
            _iterator = _createForOfIteratorHelper(node.Links);
            _context.prev = 3;

            _iterator.s();

          case 5:
            if ((_step = _iterator.n()).done) {
              _context.next = 22;
              break;
            }

            link = _step.value;

            if (!(idx < pbh.header.fanout)) {
              _context.next = 17;
              break;
            }

            linkHash = link.Hash;

            if (utils.EMPTY_KEY.equals(linkHash)) {
              _context.next = 15;
              break;
            }

            _context.next = 12;
            return _awaitAsyncGenerator(blockstore.get(linkHash));

          case 12:
            buf = _context.sent;
            _node = dagPb__namespace.decode(buf);
            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(walkItems(blockstore, _node)), _awaitAsyncGenerator), "t0", 15);

          case 15:
            _context.next = 19;
            break;

          case 17:
            _context.next = 19;
            return link.Hash;

          case 19:
            idx++;

          case 20:
            _context.next = 5;
            break;

          case 22:
            _context.next = 27;
            break;

          case 24:
            _context.prev = 24;
            _context.t1 = _context["catch"](3);

            _iterator.e(_context.t1);

          case 27:
            _context.prev = 27;

            _iterator.f();

            return _context.finish(27);

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 24, 27, 30]]);
  }));
  return _walkItems.apply(this, arguments);
}

function loadSet(_x3, _x4, _x5) {
  return _loadSet.apply(this, arguments);
}

function _loadSet() {
  _loadSet = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(blockstore, rootNode, name) {
    var link, buf, node;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            link = rootNode.Links.find(function (l) {
              return l.Name === name;
            });

            if (link) {
              _context2.next = 3;
              break;
            }

            throw new Error('No link found with name ' + name);

          case 3:
            _context2.next = 5;
            return _awaitAsyncGenerator(blockstore.get(link.Hash));

          case 5:
            buf = _context2.sent;
            node = dagPb__namespace.decode(buf);
            return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(walkItems(blockstore, node)), _awaitAsyncGenerator), "t0", 8);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadSet.apply(this, arguments);
}

function storeItems(blockstore, items) {
  return storePins(items, 0);

  function storePins(_x6, _x7) {
    return _storePins.apply(this, arguments);
  }

  function _storePins() {
    _storePins = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(pins, depth) {
      var pbHeader, header, headerBuf, fanoutLinks, i, nodes, rootLinks, rootData, bins, idx, _iterator2, _step2, bin, child, storeChild, _storeChild;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _storeChild = function _storeChild3() {
                _storeChild = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(child, binIdx) {
                  var buf, digest, cid$1, size;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          buf = dagPb__namespace.encode(child);
                          _context3.next = 3;
                          return sha2.sha256.digest(buf);

                        case 3:
                          digest = _context3.sent;
                          cid$1 = cid.CID.createV0(digest);
                          _context3.next = 7;
                          return blockstore.put(cid$1, buf);

                        case 7:
                          size = child.Links.reduce(function (acc, curr) {
                            return acc + (curr.Tsize || 0);
                          }, 0) + buf.length;
                          fanoutLinks[binIdx] = {
                            Name: '',
                            Tsize: size,
                            Hash: cid$1
                          };

                        case 9:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));
                return _storeChild.apply(this, arguments);
              };

              storeChild = function _storeChild2(_x8, _x9) {
                return _storeChild.apply(this, arguments);
              };

              pbHeader = PinSet.encode({
                version: 1,
                fanout: utils.DEFAULT_FANOUT,
                seed: depth
              }).finish();
              header = varint__default['default'].encode(pbHeader.length);
              headerBuf = concat.concat([header, pbHeader]);
              fanoutLinks = [];

              for (i = 0; i < utils.DEFAULT_FANOUT; i++) {
                fanoutLinks.push({
                  Name: '',
                  Tsize: 1,
                  Hash: utils.EMPTY_KEY
                });
              }

              if (!(pins.length <= utils.MAX_ITEMS)) {
                _context4.next = 14;
                break;
              }

              nodes = pins.map(function (item) {
                return {
                  link: {
                    Name: '',
                    Tsize: 1,
                    Hash: item.key
                  },
                  data: item.data || new Uint8Array()
                };
              }).sort(function (a, b) {
                return compare.compare(a.link.Hash.bytes, b.link.Hash.bytes);
              });
              rootLinks = fanoutLinks.concat(nodes.map(function (item) {
                return item.link;
              }));
              rootData = concat.concat([headerBuf].concat(_toConsumableArray(nodes.map(function (item) {
                return item.data;
              }))));
              return _context4.abrupt("return", {
                Data: rootData,
                Links: rootLinks
              });

            case 14:
              bins = pins.reduce(function (bins, pin) {
                var n = hash(depth, pin.key) % utils.DEFAULT_FANOUT;
                bins[n] = n in bins ? bins[n].concat([pin]) : [pin];
                return bins;
              }, []);
              idx = 0;
              _iterator2 = _createForOfIteratorHelper(bins);
              _context4.prev = 17;

              _iterator2.s();

            case 19:
              if ((_step2 = _iterator2.n()).done) {
                _context4.next = 29;
                break;
              }

              bin = _step2.value;
              _context4.next = 23;
              return storePins(bin, depth + 1);

            case 23:
              child = _context4.sent;
              _context4.next = 26;
              return storeChild(child, idx);

            case 26:
              idx++;

            case 27:
              _context4.next = 19;
              break;

            case 29:
              _context4.next = 34;
              break;

            case 31:
              _context4.prev = 31;
              _context4.t0 = _context4["catch"](17);

              _iterator2.e(_context4.t0);

            case 34:
              _context4.prev = 34;

              _iterator2.f();

              return _context4.finish(34);

            case 37:
              return _context4.abrupt("return", {
                Data: headerBuf,
                Links: fanoutLinks
              });

            case 38:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[17, 31, 34, 37]]);
    }));
    return _storePins.apply(this, arguments);
  }
}

function storeSet(_x10, _x11, _x12) {
  return _storeSet.apply(this, arguments);
}

function _storeSet() {
  _storeSet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(blockstore, type, cids) {
    var rootNode, buf, digest, cid$1, size;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return storeItems(blockstore, cids.map(function (cid) {
              return {
                key: cid
              };
            }));

          case 2:
            rootNode = _context5.sent;
            buf = dagPb__namespace.encode(rootNode);
            _context5.next = 6;
            return sha2.sha256.digest(buf);

          case 6:
            digest = _context5.sent;
            cid$1 = cid.CID.createV0(digest);
            _context5.next = 10;
            return blockstore.put(cid$1, buf);

          case 10:
            size = rootNode.Links.reduce(function (acc, curr) {
              return acc + curr.Tsize;
            }, 0) + buf.length;
            return _context5.abrupt("return", {
              Name: type,
              Tsize: size,
              Hash: cid$1
            });

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _storeSet.apply(this, arguments);
}

exports.loadSet = loadSet;
exports.storeSet = storeSet;